import { render, staticRenderFns } from "./ProfilesAssociationByProduct.vue?vue&type=template&id=06dbafa8&scoped=true&"
import script from "./ProfilesAssociationByProduct.vue?vue&type=script&lang=ts&"
export * from "./ProfilesAssociationByProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilesAssociationByProduct.vue?vue&type=style&index=0&id=06dbafa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dbafa8",
  null
  
)

export default component.exports